import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class MarketplaceManagerService {
  constructor(private httpRequest: HttpClient) {}

  getAllSolutionsInProduction() {
    const url = '/marketplace_manager_app/solution';
    return this.httpRequest.get(url);
  }

  getSolutionInMarket() {
    const url = '/marketplace_app/solution';
    return this.httpRequest.get(url);
  }

  pushSolutionIntoMarket(solution: any) {
    const url = '/marketplace_manager_app/solution';
    return this.httpRequest.post(url, solution);
  }

  updateSolutionInMarket(solution: any) {
    const url = `/marketplace_manager_app/solution?conditions={"solution_id":"${solution['solution_id']}"}`;
    return this.httpRequest.put(url, solution);
  }

  deleteSolutionFromMarketplace(solution: any) {
    const url = `/marketplace_manager_app/solution?conditions={"solution_id" : "${solution['solution_id']}"}`;
    return this.httpRequest.delete(url);
  }

  getVersionInMarket() {
    const url = `/marketplace_app/version?conditions={"is_active" : ${true}}`;
    return this.httpRequest.get(url);
  }

  getVersionsFromMarketOfSolution(solutionId: string) {
    const url = `/marketplace_app/version?conditions={"solution_id" : "${solutionId}"}`;
    return this.httpRequest.get(url);
  }

  pushVersionInMarket(data: any) {
    const url = '/marketplace_manager_app/version';
    return this.httpRequest.post(url, data);
  }

  deleteVersionFromMarketplace(version: any) {
    const url = `/marketplace_manager_app/version?conditions={"version_id" : "${version['version_id']}"}`;
    return this.httpRequest.delete(url);
  }

  getAvailableTenant() {
    const url = '/marketplace_manager_app/tenant';
    return this.httpRequest.get(url);
  }

  getSubscriptionKey(solution_id: string) {
    const url = `/marketplace_manager_app/subscription_key?conditions={"solution_id" : "${solution_id}"}`;
    return this.httpRequest.get(url);
  }

  genSubscriptionKey(data: any) {
    const url = '/marketplace_manager_app/subscription_key';
    return this.httpRequest.post(url, data);
  }

  getConfiguredWebChat() {
    const url = '/subscription_manager_app/webchat/';
    return this.httpRequest.get(url);
  }

  configureWebChat(data: any) {
    const url = '/subscription_manager_app/webchat/';
    return this.httpRequest.post(url, data);
  }
  deleteConfiguredWebChat(tenant_name: string) {
    const url = `/subscription_manager_app/webchat/${tenant_name}/`;
    return this.httpRequest.delete(url);
  }

  getConfiguredCustomHomepages() {
    const url = '/subscription_manager_app/custom-homepage/';
    return this.httpRequest.get(url);
  }

  configureHomepage(data: any) {
    const url = '/subscription_manager_app/custom-homepage/';
    return this.httpRequest.post(url, data);
  }
  deleteConfiguredHomepage(tenant_name: string) {
    const url = `/subscription_manager_app/custom-homepage/${tenant_name}/`;
    return this.httpRequest.delete(url);
  }
}
